import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { type CommentDateTranslations } from "utils";

const REFERENCE_MONDAY = new Date(Date.UTC(2026, 0, 5));

function weekdayName(locale: string, dayOffsetFromMonday: number): string {
  const date = new Date(REFERENCE_MONDAY);
  date.setUTCDate(REFERENCE_MONDAY.getUTCDate() + dayOffsetFromMonday);
  return new Intl.DateTimeFormat(locale, {
    weekday: "long",
    timeZone: "UTC",
  }).format(date);
}

export function useDateTranslations(): CommentDateTranslations {
  const { t, i18n } = useTranslation();
  const locale = i18n.language;

  return useMemo(() => {
    return {
      yesterday: t("yesterday"),
      monday: weekdayName(locale, 0),
      tuesday: weekdayName(locale, 1),
      wednesday: weekdayName(locale, 2),
      thursday: weekdayName(locale, 3),
      friday: weekdayName(locale, 4),
      saturday: weekdayName(locale, 5),
      sunday: weekdayName(locale, 6),
    };
  }, [t, locale]);
}
